
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderProductSpecificationsGrid extends Serenity.EntityGrid<OrderProductSpecificationsRow, any> {
        protected getColumnsKey() { return 'Orders.OrderProductSpecifications'; }
        protected getDialogType() { return OrderProductSpecificationsDialog; }
        protected getIdProperty() { return OrderProductSpecificationsRow.idProperty; }
        protected getInsertPermission() { return OrderProductSpecificationsRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderProductSpecificationsRow.localTextPrefix; }
        protected getService() { return OrderProductSpecificationsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            
        }

        protected addButtonClick() {

            this.editItem({ OrderId: this.OrderId });
        }

        protected usePager() {
            return false;
        }

        protected getGridCanLoad() {

            return this.OrderId != null;
        }


        private _OrderId: number;
        

        get OrderId() {
            return this._OrderId;
        }

       

        set OrderId(value: number) {
            if (this._OrderId != value) {
                this._OrderId = value;
                this.setEquality(OrderProductSpecificationsRow.Fields.OrderId, value);
                this.refresh();
            }
        }

       

       
    }
}